<template>
  <div class="bg">
    <div class="content">
      <h2>调查问卷</h2>
      <el-form :model="form" label-width="auto" ref="ruleFormRef" label-position="top" status-icon>
        <el-form-item label="姓名" prop="Name" :rules="[
        {
          required: true,
          message: '请输入姓名',
          trigger: 'blur',
        }
      ]">
          <el-input v-model="form.Name" placeholder="请输入姓名"/>
        </el-form-item>
        <el-form-item
            label="手机号"
            prop="Phone"
            :rules="[
        {
          required: true,
          message: '请输入手机号',
          trigger: 'blur',
        }
      ]"
        >
          <el-input v-model="form.Phone" placeholder="请输入手机号"/>
        </el-form-item>
        <el-form-item label="学校"
                      prop="value"
                      :rules="[
        {
          required: true,
          message: '请选择学校',
          trigger: 'blur',
        }
      ]">
          <el-cascader
              style="width: 100%;"
              placeholder="请选择学校"
              v-model="form.value"
              :options="data"
              :props="props"
              @change="handleChange"
          />
        </el-form-item>
        <el-form-item label="测评对象"
                      prop="FillRole"
                      :rules="[
        {
          required: true,
          message: '请选择测评对象',
          trigger: 'blur',
        }
      ]">
          <el-select v-model="form.FillRole" placeholder="请选择测评对象">
            <el-option label="学生家长" value="学生家长" />
            <el-option label="附近商户或居民" value="附近商户或居民" />
            <el-option label="教职工" value="教职工" />
            <el-option label="学校领导" value="学校领导" />
            <el-option label="教育部门主管" value="教育部门主管" />
            <el-option label="其他" value="其他" />
          </el-select>
          <el-input style="margin-top: 10px;" v-if="form.FillRole === '其他'" v-model="form.FillRoleExtra" placeholder="请输入测评对象"/>
        </el-form-item>
        <el-form-item prop="Question1" label="您对学校周边交通拥堵减少，交通顺畅情况，感到满意吗？"
                      :rules="[
        {
          required: true,
          message: '请选择该选项',
          trigger: 'blur',
        }
      ]">
          <el-radio-group v-model="form.Question1">
            <el-radio value="A 非常满意">A 非常满意</el-radio>
            <el-radio value="B 满意">B 满意</el-radio>
            <el-radio value="C 不满意">C 不满意</el-radio>
            <el-radio value="D 很不满意">D 很不满意</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="Question2" label="学校是否向家长清晰告知标明交通路线、停车资源等信息的交通组织图？"
                      :rules="[
        {
          required: true,
          message: '请选择该选项',
          trigger: 'blur',
        }
      ]">
          <el-radio-group v-model="form.Question2">
            <el-radio value="A 清晰告知">A 清晰告知</el-radio>
            <el-radio value="B 告知了但不是很清晰">B 告知了但不是很清晰</el-radio>
            <el-radio value="C 不清楚是否告知">C 不清楚是否告知</el-radio>
            <el-radio value="D 没有告知">D 没有告知</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="Question3" label="您对学校周边的护学岗，高峰时段校园周边见警率、管事率满意吗？"
                      :rules="[
        {
          required: true,
          message: '请选择该选项',
          trigger: 'blur',
        }
      ]">
          <el-radio-group v-model="form.Question3">
            <el-radio value="A 非常满意">A 非常满意</el-radio>
            <el-radio value="B 较满意">B 较满意</el-radio>
            <el-radio value="C 不满意">C 不满意</el-radio>
            <el-radio value="D 很不满意">D 很不满意</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="Question4" label="是否完善“家校警+”护学模式，家长、校方能够协助交警使交通秩序得以改善？"
                      :rules="[
        {
          required: true,
          message: '请选择该选项',
          trigger: 'blur',
        }
      ]">
          <el-radio-group v-model="form.Question4">
            <el-radio value="A 很完善">A 很完善</el-radio>
            <el-radio value="B 还可以">B 还可以</el-radio>
            <el-radio value="C 不明显">C 不明显</el-radio>
            <el-radio value="D 没有改善">D 没有改善</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="Question5" label="学校是否经常通过家长会、小手拉大手、家长微信群等形式。引导家长提高公德意识，自觉维护校园周边交通秩序？"
                      :rules="[
        {
          required: true,
          message: '请选择该选项',
          trigger: 'blur',
        }
      ]">
          <el-radio-group v-model="form.Question5">
            <el-radio value="A 经常组织">A 经常组织</el-radio>
            <el-radio value="B 偶尔组织">B 偶尔组织</el-radio>
            <el-radio value="C 不清楚是否组织过">C 不清楚是否组织过</el-radio>
            <el-radio value="D 从来没有组织过">D 从来没有组织过</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="Question6" label="您觉得交管部门对学校周围违法乱象的管控力度怎样？"
                      :rules="[
        {
          required: true,
          message: '请选择该选项',
          trigger: 'blur',
        }
      ]">
          <el-radio-group v-model="form.Question6">
            <el-radio value="A 严格管控，效果很好">A 严格管控，效果很好</el-radio>
            <el-radio value="B 管控效果较好">B 管控效果较好</el-radio>
            <el-radio value="C 管控效果一般">C 管控效果一般</el-radio>
            <el-radio value="D 没有管控过">D 没有管控过</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="Question7" label="学校周围是否建设临时停车场、开辟远端停车场，或者引导学生统一步行至远端集中上下车，向外围疏解接送学生停车需求，协调周边限时共享停车场，推行附近学校家长限时免费政策，推动共享学校周边停车资源？"
                      :rules="[
        {
          required: true,
          message: '请选择该选项',
          trigger: 'blur',
        }
      ]">
          <el-radio-group v-model="form.Question7">
            <el-radio value="A 有，周边很好停车">A 有，周边很好停车</el-radio>
            <el-radio value="B 部分实施，周边较好停车">B 部分实施，周边较好停车</el-radio>
            <el-radio value="C 效果不明显，还是存在停车问题">C 效果不明显，还是存在停车问题</el-radio>
            <el-radio value="D 没有，学校周边很难停车">D 没有，学校周边很难停车</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="Question8" label="学校是否实行错峰上下学制度？"
                      :rules="[
        {
          required: true,
          message: '请选择该选项',
          trigger: 'blur',
        }
      ]">
          <el-radio-group v-model="form.Question8">
            <el-radio value="A 实施了，效果很好">A 实施了，效果很好</el-radio>
            <el-radio value="B 实施了，但是效果不太理想">B 实施了，但是效果不太理想</el-radio>
            <el-radio value="C 不清楚">C 不清楚</el-radio>
            <el-radio value="D 完全没有">D 完全没有</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="Question9" label="学校是否有通过增开校门的方式缓解交通压力？"
                      :rules="[
        {
          required: true,
          message: '请选择该选项',
          trigger: 'blur',
        }
      ]">
          <el-radio-group v-model="form.Question9">
            <el-radio value="A 实施了，效果很好">A 实施了，效果很好</el-radio>
            <el-radio value="B 实施了，但是效果不太理想">B 实施了，但是效果不太理想</el-radio>
            <el-radio value="C 不清楚">C 不清楚</el-radio>
            <el-radio value="D 完全没有">D 完全没有</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="Question10" label="学校门口是否设置缓冲区，在缓冲区与道路交界处设置拒马、隔离墩、升降柱等硬质防冲撞设施，对上下学期间学生聚集区域进行防护隔离？"
                      :rules="[
        {
          required: true,
          message: '请选择该选项',
          trigger: 'blur',
        }
      ]">
          <el-radio-group v-model="form.Question10">
            <el-radio value="A 设置了，效果很好">A 设置了，效果很好</el-radio>
            <el-radio value="B 设置了，但是效果不太理想">B 设置了，但是效果不太理想</el-radio>
            <el-radio value="C 不清楚">C 不清楚</el-radio>
            <el-radio value="D 完全没有相关设施">D 完全没有相关设施</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="Question11" label="您觉得学校周边公交线路、公交频次辆次是否合理？"
                      :rules="[
        {
          required: true,
          message: '请选择该选项',
          trigger: 'blur',
        }
      ]">
          <el-radio-group v-model="form.Question11">
            <el-radio value="A 非常合理">A 非常合理</el-radio>
            <el-radio value="B 比较合理">B 比较合理</el-radio>
            <el-radio value="C 不合理">C 不合理</el-radio>
            <el-radio value="D 很不合理">D 很不合理</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="Question12" label="是否在学校路段看到“学校区域警告标志”、“机动车限速标志”、“过街设施”、“信号灯”、“禁停网状线”等交管警告标识？"
                      :rules="[
        {
          required: true,
          message: '请选择该选项',
          trigger: 'blur',
        }
      ]">
          <el-radio-group v-model="form.Question12">
            <el-radio value="A 看到了">A 看到了</el-radio>
            <el-radio value="B 不是很明显">B 不是很明显</el-radio>
            <el-radio value="C 不清楚">C 不清楚</el-radio>
            <el-radio value="D 完全没有看到">D 完全没有看到</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="Question13" label="学校周围是否存在人车混行、设施不全、秩序混乱等交通事故隐患？"
                      :rules="[
        {
          required: true,
          message: '请选择该选项',
          trigger: 'blur',
        }
      ]">
          <el-radio-group v-model="form.Question13">
            <el-radio value="A  没有，学校周围秩序良好">A  没有，学校周围秩序良好</el-radio>
            <el-radio value="B 学校周围秩序比较好">B 学校周围秩序比较好</el-radio>
            <el-radio value="C 不太清楚">C 不太清楚</el-radio>
            <el-radio value="D 学校周围秩序很不好">D 学校周围秩序很不好</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="Question14" label="学校周边施工是否对道路通行造成了不便？"
                      :rules="[
        {
          required: true,
          message: '请选择该选项',
          trigger: 'blur',
        }
      ]">
          <el-radio-group v-model="form.Question14">
            <el-radio value="A 交管部门处理得很好，已经尽可能减少影响">A 交管部门处理得很好，已经尽可能减少影响</el-radio>
            <el-radio value="B 通行受到了部分影响">B 通行受到了部分影响</el-radio>
            <el-radio value="C 影响较大">C 影响较大</el-radio>
            <el-radio value="D 严重影响通行">D 严重影响通行</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="Question15" label="学校周围是否存在占道经营、临时摆摊和马路市场等现象？"
                      :rules="[
        {
          required: true,
          message: '请选择该选项',
          trigger: 'blur',
        }
      ]">
          <el-radio-group v-model="form.Question15">
            <el-radio value="A 没有此类情况">A没有此类情况</el-radio>
            <el-radio value="B 偶尔会有">B 偶尔会有</el-radio>
            <el-radio value="C 经常会有">C 经常会有</el-radio>
            <el-radio value="D 摊贩严重影响交通">D 摊贩严重影响交通</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="Question16" label="学校周围是否存在长期占用停车位的车辆和“僵尸车”？"
                      :rules="[
        {
          required: true,
          message: '请选择该选项',
          trigger: 'blur',
        }
      ]">
          <el-radio-group v-model="form.Question16">
            <el-radio value="A 没有">A 没有</el-radio>
            <el-radio value="B 不清楚">B 不清楚</el-radio>
            <el-radio value="C 好像有">C 好像有</el-radio>
            <el-radio value="D 有此类车辆占用车位">D 有此类车辆占用车位</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="Question17" label="您认为学校周边公交站点设置是否合理？"
                      :rules="[
        {
          required: true,
          message: '请选择该选项',
          trigger: 'blur',
        }
      ]">
          <el-radio-group v-model="form.Question17">
            <el-radio value="A 很合理">A 很合理</el-radio>
            <el-radio value="B 较为合理">B 较为合理</el-radio>
            <el-radio value="C 不合理">C 不合理</el-radio>
            <el-radio value="D 很不合理">D 很不合理</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="Question18" label="您在学校周边是否见到农用车、报废车、“三无”车辆、非法营运车辆接送学生？"
                      :rules="[
        {
          required: true,
          message: '请选择该选项',
          trigger: 'blur',
        }
      ]">
          <el-radio-group v-model="form.Question18">
            <el-radio value="A 没有">A 没有</el-radio>
            <el-radio value="B 不清楚">B 不清楚</el-radio>
            <el-radio value="C 偶尔有">C 偶尔有</el-radio>
            <el-radio value="D 经常有">D 经常有</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="Question19" label="交管部门或者学校是否通过网络、电视、 广播、报刊、公益广告等形式，常态化开展交通安全公益宣传活动？"
                      :rules="[
        {
          required: true,
          message: '请选择该选项',
          trigger: 'blur',
        }
      ]">
          <el-radio-group v-model="form.Question19">
            <el-radio value="A 有，效果很好">A 有，效果很好</el-radio>
            <el-radio value="B 有，但是效果不太理想">B 有，但是效果不太理想</el-radio>
            <el-radio value="C 不清楚">C 不清楚</el-radio>
            <el-radio value="D 完全没有">D 完全没有</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="Question20" label="校方或者交管部门是否建立常态化协同联动机制， 将“校园”畅安工程推进情况纳入“平安校园”创建工作？"
                      :rules="[
        {
          required: true,
          message: '请选择该选项',
          trigger: 'blur',
        }
      ]">
          <el-radio-group v-model="form.Question20">
            <el-radio value="A 有，效果很好">A 有，效果很好</el-radio>
            <el-radio value="B 有，但是效果不太理想">B 有，但是效果不太理想</el-radio>
            <el-radio value="C 不清楚">C 不清楚</el-radio>
            <el-radio value="D 完全没有相关机制">D 完全没有相关机制</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="Question21" label="学校是否定期通报交通安全、联席会议和联合惩戒制度，为交管部门、教体部门与学校教职员工、学生家长签订交通安全责书，起到了监管作用？"
                      :rules="[
        {
          required: true,
          message: '请选择该选项',
          trigger: 'blur',
        }
      ]">
          <el-radio-group v-model="form.Question21">
            <el-radio value="A 是，效果很好">A 是，效果很好</el-radio>
            <el-radio value="B 部分实施">B 部分实施</el-radio>
            <el-radio value="C 不清楚">C 不清楚</el-radio>
            <el-radio value="D 完全没有相关制度">D 完全没有相关制度</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="Question22" label="畅安工程实施以来，您对校园周边的交通情况整体评价是？"
                      :rules="[
        {
          required: true,
          message: '请选择该选项',
          trigger: 'blur',
        }
      ]">
          <el-radio-group v-model="form.Question22">
            <el-radio value="A 很满意">A 很满意</el-radio>
            <el-radio value="B 比较满意">B 比较满意</el-radio>
            <el-radio value="C 一般">C 一般</el-radio>
            <el-radio value="D 很不满意">D 很不满意</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button size="large" type="primary" @click="submitForm(ruleFormRef)">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script setup>
import {ref, reactive} from "vue";
import {schoolList,parseTime} from "@/assets/school";
import axios from 'axios';

const form = reactive({
  FillTime: '',
  FormName: '文件内容',
  FormCode: 'D20',
  QrName: '鄂尔多斯市校园畅安工程满意度测评',
  QrUrl: 'https://h5.clewm.net/?url=qr71.cn%2FoS5bZd%2FqSmaJRa',
  FillWay: '电脑web',
})
const data = ref([])
const value = ref()
const ruleFormRef = ref()
const props = {label: 'label', value: 'label'}
const getSchool = () => {
  let arr
  for (let i in schoolList) {
    arr = {
      label: i,
      children: []
    }
    schoolList[i].forEach(item => {
      const obj = {
        label: item
      }
      arr.children.push(obj)
    })
    data.value.push(arr)
  }
}
getSchool()
const handleChange = (val) => {
  form.Area = val[0]
  form.School = val[1]
}
const submitForm = async (formEl) => {
  if (!formEl) return
  await formEl.validate((valid, fields) => {
    if (valid) {
      form.FillTime = parseTime(new Date())
      axios.post('http://39.104.228.231:9900/question/upload', form).then(response => {
        formEl.resetFields()
      }).catch(error => {
        console.error('请求后端接口失败:', error);
      });
    } else {
      console.log('error submit!', fields)
    }
  })
}
</script>

<style scoped lang="scss">
.bg {
  width: 100%;

  .content {
    width: 800px;
    margin: 0 auto;
  }
}
</style>
